import {getProjects} from '../../utils/sanity/sanity';

async function GetPortfolioData(){

  const projectData = await getProjects();
  return projectData;

}

export default GetPortfolioData;